/* "Sign in, then come back" for per-record links (2026-10-27).
 *
 * Someone opening /admin/shop-payments/383ui-aj392 without a session (or whose session expired)
 * is sent to the login page as /admin?next=/admin/shop-payments/383ui-aj392, and after signing in
 * lands on that record instead of the dashboard. Signing in grants nothing extra: the record is
 * still looked up with the user's own scope, server-side.
 */

const PROTECTED = /^\/(admin|report)\//;

/* The login URL that brings the user back to `path` (default: where they are now). */
export function loginUrlFor(path) {
    const here = path || (typeof window !== 'undefined' ? window.location.pathname + window.location.search : '');
    return PROTECTED.test(here) ? `/admin?next=${encodeURIComponent(here)}` : '/admin';
}

/* Where to go after a successful login: the `next` from the URL when it is one of this app's own
 * protected pages, otherwise the dashboard. Anything else (another site, "//evil.example",
 * "javascript:") is ignored, so the parameter cannot be used to send someone off-site. */
export function afterLoginPath(search) {
    try {
        // Pass the router's location.search where there is one: the browser's address bar may have
        // moved on already (signing in sets off two redirects, and the second must still see ?next=).
        const from = typeof search === 'string' ? search : window.location.search;
        const next = new URLSearchParams(from).get('next') || '';
        if (PROTECTED.test(next) && !next.startsWith('//') && !/[\\\s]/.test(next)) return next;
    } catch (e) { /* fall through */ }
    return '/admin/dashboard';
}
